<template>
	<div>
		<div class="seatBindingBtn">
			<el-button size="medium" type="primary" @click="addServer">添加</el-button>
			<el-button size="medium" type="danger" :disabled="selectServer.length == 0" @click="delServer">
				删除
				<span v-if="selectServer.length > 0">({{ selectServer.length }})</span>
			</el-button>
		</div>
		<el-table v-loading="loading" class="tableStyle" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="55" align="center"></el-table-column>
			<el-table-column prop="name" label="服务器名称" width="180" align="center"></el-table-column>
			<el-table-column prop="ctiserver" label="CTI地址" width="180" align="center"></el-table-column>
			<el-table-column prop="sipserver" label="SIP地址" width="180" align="center"></el-table-column>
			<el-table-column prop="companyCode" label="企业标识号" width="180" align="center"></el-table-column>
			<el-table-column prop="apiserver" label="API地址" align="center"></el-table-column>
			<el-table-column prop="apitoken" label="Token地址" align="center"></el-table-column>
			<el-table-column prop="clientCode" label="客户标识号" align="center"></el-table-column>
			<el-table-column prop="dialType" label="拨号类型" align="center">
				<template slot-scope="scope">
					<span v-if="scope.row.dialType == 1">九五</span>
					<span v-else-if="scope.row.dialType == 2">华旗</span>
					<span v-else-if="scope.row.dialType == 3">测试</span>
					<span v-else>其他</span>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="操作" width="120" align="center">
				<template slot-scope="scope">
					<el-button  @click.native.prevent="deitServer(scope)" type="text">修改</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination
				background
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="pagination.pageNo"
				:page-sizes="[10, 50, 100, 200, 300, 400]"
				:page-size="pagination.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="pagination.total"
			></el-pagination>
		</div>
		<!-- 添加修改 详情 -->
		<serverDeployDetails ref="serverDeployDetails" @serverOk="serverOk"></serverDeployDetails>
	</div>
</template>

<script>
import serverDeployDetails from './serverDeployDetails';
export default {
	components: {
		serverDeployDetails
	},
	data() {
		return {
			selectServer: [], //选择数据
			tableData: [],
			pagination: {
				pageNo: 1,
				total: 0,
				pageSize: 10
			},
			loading: false
		};
	},
	created() {
		this.loadData();
	},
	methods: {
		serverOk() {
			this.loadData();
		},
		handleSelectionChange(val) {
			let tempSelectServer = [];
			val.forEach(item => {
				tempSelectServer.push(item.id);
			});
			this.selectServer = tempSelectServer;
		},
		delServer() {
			if(this.selectServer.length==0){
				this.$message.warning('请选择一条数据');
				return false
			}
			this.$confirm('确定删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let that = this;
					let params = {
						that: this,
						url: `${this.$config.service.serverDel}?ids=${that.selectServer.toString()}`,
						method: 'GET',
						data: {},
						cb(res) {
							if (res.code == 0) {
								that.loadData();
								that.$message.success(res.message);
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		// 编辑
		deitServer(scope) {
			this.$refs.serverDeployDetails.form = JSON.parse(JSON.stringify(scope.row));
			this.$refs.serverDeployDetails.editDetails();
		},
		// 添加
		addServer() {
			this.$refs.serverDeployDetails.addDetails();
		},
		handleSizeChange(val) {
			this.pagination.pageSize = val;
			this.pagination.pageNo = 1;
		},
		handleCurrentChange(val) {
			this.pagination.pageNo = val;
		},
		loadData() {
			this.loading = true
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.serverList}?pageIndex=${this.pagination.pageNo}&pageSize=${this.pagination.pageSize}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.tableData = res.resultBody.datas;
						that.pagination.total = res.resultBody.total;
					} else {
						that.tableData = [];
						that.pagination.total = 0;
						that.$message.error(res.message);
					}
				},
				finally() {
					that.loading = false
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style>
.seatBindingBtn {
	display: flex;
	justify-content: space-between;
}
.tableStyle {
	margin-top: 20px;
}
.block {
	text-align: right;
	margin-top: 20px;
}
</style>
